import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import { cardData } from '../interfaces/CardData'
import { db, auth } from '../firebase/config.js';

export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      claims: null,
      data: null
    },
    select: {
      user: {
        data: null
      },
      breed: {
        data: null
      },
      dog: {
        id: null,
        data: null
      },
      subs: {
        id: null,
        data: null
      },
      card: cardData,
    }
  },
  getters: {
    user(state){
      return state.user
    },
    _user(state){
      return state.select.user
    },
    _breed(state){
      return state.select.breed
    },
    _dog(state){
      return state.select.dog
    },
    _card(state){
      return state.select.card
    },
    _subs(state){
      return state.select.subs
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, data) {
      state.user = data;
    },
    SET_USER_CLAIMS(state, data) {
      state.user.claims = data;
    },
    SET_SEL_USER(state, data) {
      state.select.user = data;      
    },
    SET_SEL_BREED(state, data) {
      state.select.breed = data;   
    },
    SET_SEL_DOG(state, data) {
      state.select.dog = data;  
    },
    SET_SEL_CARD(state, data) {
      state.select.card = data; 
    },
    SET_SEL_SUBS(state, data) {
      state.select.subs = data; 
    }
  },
  actions: {
    // fetchUser({ commit }, user) {
    //   commit("SET_LOGGED_IN", user !== null);
    //   if (user) {
    //     commit("SET_USER", {
    //       ...user,
    //     });
    //   } else {
    //     commit("SET_USER", null);
    //   }
    // }
    fetchUser({ dispatch, commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      console.log('fetchUser-user: ', user)
      return dispatch('getExtendedUser').then((extended_user) => {
        if(extended_user) {
          console.log('fetchUser-extended_user: ', extended_user)
          commit("SET_USER", {
            ...extended_user
          })
        } else {
          commit("SET_USER", null);
        }
      })
    },
    getExtendedUser() {
      return new Promise((resolve, reject) => {
        //START
        //console.log(user.displayName, user.uid, "LOGIN OK!");
        const user = auth.currentUser
        if(!user) {
          reject(new Error('Invalid Credential'))//throw new Error('Invalid Credential');
        }
        // Get user token
        auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {
          // Get customClaims if they are defined
          if (!idTokenResult.claims) {
            reject(new Error('Claims undefined'))//throw new Error('Claims undefined')
          }
          const claims = {
            isAdmin: idTokenResult.claims.isAdmin,
            orgId: idTokenResult.claims.orgId,
            role: idTokenResult.claims.role
          }
          console.log('claims', claims)
          // get store / company name
          let storeId = 'undefined!'
          let storeName = 'undefined!'
          let storeDefaults = {}
          let storeSelfApp = {}

          const stores = []
          db.collection('stores')
          .where('orgId', '==', claims.orgId)
          .get()
          .then((snapShot) => {
            snapShot.forEach((doc) => {
              if(!doc.exists) throw new Error('No Stores for OrgId:', claims.orgId)
              console.log('store', doc.id, doc.data())
              stores.push({
                id: doc.id,
                ...doc.data()
              })
            })
            if(stores.length == 1) {
              storeId = stores[0].id
              storeName = stores[0].name + ' (' + stores[0].defaults.province + ')'
              storeDefaults = stores[0].defaults
              storeSelfApp = stores[0].storeSelfApp
            } else { 
              alert('ERROR: multiple stores for same orgId NOT still managed!')
              throw new Error('Multiple stores NOT managed for orgId', claims.orgId)
            }
            if(storeSelfApp.eCom) {
              //test=true -> modalità eCommerce solo in modalità di TEST su userId specifico
              if(storeSelfApp.testEcom &&
                storeSelfApp.testUserId != user.uid) {
                alert('DogMotics WebApp eCom in modalità test su UserId specifico')
                /*throw new Error('DogMotics WebApp eCom in test mode on userId: ', storeSelfApp.testUserId)*/
                storeSelfApp.eCom = false
              }
            }
            const extended_user = {
              loggedIn: true,
              claims,
              ...user,
              storeId: storeId,
              storeName: storeName,
              storeDefaults: storeDefaults,
              storeSelfApp: storeSelfApp
            }
            console.log('Extended user: ', extended_user)
            resolve(extended_user)
          })
          .catch((err) => {
            console.log(err);
            reject(new Error(err.message + 'Organization not found'))
          })
        })
        .catch((err) => {
          console.log(err);
          //throw new Error(err.message + 'Token not found');
          reject(new Error(err.message + 'Token not found'))
        })
        //END
      })
    }
  }
});